/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetCommitteeService,
  IGetCommitteeMethods,
  IDeleteBoxMethods,
  DeleteBoxService,
  ISendRemainderMethods,
  SendRemainderService,
} from "./components";

export type PrebookToActualBoxes = IStaticPageContentMethods &
  IGetCommitteeMethods &
  ISendRemainderMethods &
  IDeleteBoxMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetCommitteeService(),
    new DeleteBoxService(),
    new SendRemainderService(),
  ];
};

export const getAgent = () => {
  return createAgent<PrebookToActualBoxes>({
    plugins: getPlugins(),
  });
};
